import type { FaireProductEntity } from "../../entity_types/product";

export const p_gdtubhx5pw: FaireProductEntity = {
  token: "p_gdtubhx5pw",
  type: "product",
  name: "Cold Snap Non-Alc Kombucha | E+Rose Collab",
  brandToken: "b_s2jesyk5p9",
  brandName: "Walker Brothers",
  imageUrl: "https://cdn.faire.com/fastly/0e17f7f62250bd5e145c70a87e7a3c63f14676cbea7f9eb2b5b4b44dbbbbffe3.png",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/cb1875ffd190b717dc286744c017f53853e731dd92b6198883896e967f07baaa.png"
  ],
  priceDollars: 2.25,
  description: "Our newest non-alc limited-release was made in collaboration with our friends at E+Rose. Made with their best-selling organic green apple, ginger, mint, kale, spinach, parsley and chard juice – Cold Snap – this kombucha is a crisp with a ginger bite and clean mint taste.\n\n• Non Alcoholic\n• Gluten-Free\n• Vegan\n• Rich in Live Probiotics\n\nPlease note: This item must be kept refrigerated.\n\nA healthy, non-alcoholic option for fall gatherings, tailgates, Halloween, Thanksgiving, Friendsgiving and holiday parties! A great mixer for drinks as well as a good snack pairing with chips and popcorn. ",
  tags: [],
  msrpDollars: 4.5,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-10-09T08:04:42.503Z",
    importedBy: "entity-db-cli"
  },
  categoryTokens: []
};
